import React, {Component} from 'react';
import Footer from '../exercise/Footer';
import ImgPreview from '../components/imgPreview'

class Question extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            previewVisible:false
        };
    }
    toggleAnswer = (val, e) => {
        e.stopPropagation();
        this.setState({visible: val});
    };
    //图片预览
	handlePreviewImg=(status)=>{
		this.setState({previewVisible:status})
	}
    componentDidMount() {}

    render() {
        const {visible,previewVisible} = this.state;
        const {num, children} = this.props;
        let originData = this.props.data;
        //题目检错页显示的是错的的答题答案
        if(this.props.errorAnswer){
        		originData.answer = this.props.errorAnswer
        }
		
        let stem = JSON.parse(originData.stem)
        
        return (
            <div className="box-exercise" ref={'viewer'}>
                <div className="exercise-content">
                    {num!=='undefined'&&<div className="exercise-num"><span className="math_text">{`${num + 1}、`}</span></div>}
                    <div className="exercise-con">
                        <span className="form-label">中文引导语：</span>
                        <div className="form-content">{stem.guide_text}</div>
                        <span className="form-label">引导语音频：</span>
                        <div className="form-content">
                             <audio  src={stem.guide_audio} controls="controls">您的浏览器不支持</audio>
                        </div>
                        <span className="form-label">问题图片：</span>
                        <div className="form-content">
                        		<img src={stem.img}  width={120} onClick={()=>this.handlePreviewImg(true)}  style={{maxHeight:70}}/>
                        		<ImgPreview previewVisible={previewVisible} previewImage={stem.img} handlePreviewImg={this.handlePreviewImg}/>
                        </div>
                        
                        <span className="form-label">英文问题：</span>
                        <div className="form-content">{stem.english_text}</div>
                        <span className="form-label">问题音频：</span>
                        <div className="form-content">
                              <audio  src={stem.english_audio} controls="controls">您的浏览器不支持</audio>
                        </div>    
                        <span className="form-label">答题时间：</span>
                        <div className="form-content">{stem.answer_time}s</div>
                        
                    </div>

                </div>
                <div className="exercise-footer">
                    {
                        visible &&
                        <div className="footer-hide relative">
                            <div>
                                <div className="inline-block answer">{this.props.errorAnswer?'错误答案：':'正确答案：'}</div>
                                <div className="inline-block answer" >{JSON.parse(this.props.data.answer).join(";")}</div>
                            </div>
                        </div>
                    }
                    <div className="footer-show relative">
                        <Footer {...this.props} obj={originData} subject={this.props.data.subject}>
                             {
                                this.props.canShowAnswer ?
                                    <button className="question-btn"onClick={(e) => this.toggleAnswer(!visible,e)}>
                                        {!visible ? '显示答案' : '隐藏答案'}
                                    </button> : null
                            }

                        </Footer>
                    </div>
                </div>
            </div>


        )
    }
}


export default Question;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/situationalDialogue/viewForView.js